// @flow
import { defineMessages } from 'react-intl'

export default defineMessages({
  now: { id: 'common.now', defaultMessage: `now` },
  at: { id: 'common.at', defaultMessage: 'at' },
  view: { id: 'common.view', defaultMessage: `View` },
  views: { id: 'common.views', defaultMessage: `Views` },
  remove: { id: 'common.remove', defaultMessage: `Remove` },
  leave: { id: 'common.leave', defaultMessage: `Leave` },
  add: { id: 'common.add', defaultMessage: `Add` },
  terms: { id: 'common.terms', defaultMessage: 'Terms' },
  privacy: { id: 'common.privacy', defaultMessage: 'Privacy' },
  subscribe: { id: 'common.subscribe', defaultMessage: `Subscribe` },
  subscribed: { id: 'common.subscribed', defaultMessage: `Subscribed` },
  unsubscribe: { id: 'common.unsubscribe', defaultMessage: 'Unsubscribe' },
  resubscribe: { id: 'common.resubscribe', defaultMessage: 'Re-Subscribe' },
  follow: { id: 'common.follow', defaultMessage: `Follow` },
  following: { id: 'common.following', defaultMessage: `Following` },
  member: { id: 'common.member', defaultMessage: `Member` },
  members: { id: 'common.members', defaultMessage: `Members` },
  collaborators: {
    id: 'common.collaborators',
    defaultMessage: `Collaborators`,
  },
  pending: { id: 'common.pending', defaultMessage: `Pending` },
  invite: { id: 'common.invite', defaultMessage: `Invite` },
  message: { id: 'common.message', defaultMessage: `Message` },
  invites: { id: 'common.invites', defaultMessage: `Invites` },
  private: { id: 'common.private', defaultMessage: `Private` },
  settings: { id: 'common.settings', defaultMessage: `Settings` },
  sidebar: { id: 'common.sidebar', defaultMessage: 'Sidebar' },
  signIn: { id: 'common.sign.in', defaultMessage: `Sign in` },
  singleSignIn: { id: 'common.single.sign.in', defaultMessage: ` Single Sign-on` },
  featureToggles: { id: 'common.feature.toggles', defaultMessage: `Feature Toggles` },
  joinNow: { id: 'common.join.now', defaultMessage: `Join Now` },
  signUp: { id: 'common.sign.up', defaultMessage: `Sign up` },
  noDateProvided: { id: 'common.nodate', defaultMessage: `No Date provided` },
  sendMeASignInLink: {
    id: 'common.send.me.a.sign.in.link',
    defaultMessage: `Send me a sign-in link.`,
  },
  forgotPassword: {
    id: 'common.forgot.password',
    defaultMessage: `Forgot password?`,
  },
  signOut: { id: 'common.sign.out', defaultMessage: `Sign out` },
  createAccount: {
    id: 'common.create.account',
    defaultMessage: `Create Account`,
  },
  points: { id: 'common.points', defaultMessage: `Points` },
  viewProfile: { id: 'common.view.profile', defaultMessage: `View Profile` },
  team: { id: 'common.team', defaultMessage: `Team` },
  home: { id: 'common.home', defaultMessage: `Home` },
  collections: { id: 'common.collections', defaultMessage: `Collections` },
  collection: { id: 'common.collection', defaultMessage: `Collection` },
  archive: { id: 'common.archive', defaultMessage: 'Archive' },
  all: { id: 'common.all', defaultMessage: `All` },
  search: { id: 'common.search', defaultMessage: `Search` },
  postedIn: { id: 'common.posted.in', defaultMessage: `Posted in` },
  relatedPosts: { id: 'common.related.posts', defaultMessage: `Related Posts` },
  upNext: { id: 'common.up.next', defaultMessage: `Up Next` },
  next: { id: 'common.next', defaultMessage: `Next` },
  previous: { id: 'common.previous', defaultMessage: `Previous` },
  like: { id: 'common.like', defaultMessage: `Like` },
  likes: { id: 'common.likes', defaultMessage: `Likes` },
  comment: { id: 'common.comment', defaultMessage: `Contribute` },
  repost: { id: 'common.repost', defaultMessage: `Repost` },
  post: { id: 'common.post', defaultMessage: `Post` },
  totalLikes: { id: 'common.total.likes', defaultMessage: `Total Likes` },
  totalViews: { id: 'common.total.views', defaultMessage: `Total Views` },
  noResultsFound: {
    id: 'common.no.results.found',
    defaultMessage: `No results found`,
  },
  whatDoYouWantToShare: {
    id: 'common.what.do.you.want.to.share',
    defaultMessage: `What do you want to share?`,
  },
  addLink: { id: 'common.add.link', defaultMessage: `Add Link` },
  uploadFile: { id: 'common.upload.file', defaultMessage: `Upload File` },
  upload: { id: 'common.upload', defaultMessage: `Upload` },
  shareLink: { id: 'common.share.link', defaultMessage: `Share Link` },
  addAccount: { id: 'common.add.acount', defaultMessage: `Add Account` },
  email: { id: 'common.email', defaultMessage: `Email` },
  emails: { id: 'common.emails', defaultMessage: `Email ` },
  firstName: { id: 'common.firstname', defaultMessage: 'First Name' },
  lastName: { id: 'common.lastname', defaultMessage: 'Last Name' },
  password: { id: 'common.password', defaultMessage: `Password` },
  fullName: { id: 'common.full.name', defaultMessage: `Full Name` },
  displayName: { id: 'common.display.name', defaultMessage: `Display Name` },
  join: { id: 'common.join', defaultMessage: `Join` },
  more: { id: 'common.more', defaultMessage: `More` },
  viewMore: { id: 'common.view.more', defaultMessage: `View More` },
  requestSent: { id: 'common.request.sent', defaultMessage: `Request Sent` },
  signInWith: { id: 'common.sign.in.with', defaultMessage: `Sign in with` },
  signUpWithEmail: {
    id: 'common.sign.up.with.email',
    defaultMessage: `Sign up with Email`,
  },
  compose: { id: 'common.compose', defaultMessage: `Compose` },
  manageContent: {
    id: 'common.manage.content',
    defaultMessage: `Manage Content`,
  },
  scheduled: { id: 'common.scheduled', defaultMessage: `Scheduled` },
  schedule: { id: 'common.schedule', defaultMessage: 'Schedule' },
  drafts: { id: 'common.drafts', defaultMessage: `Drafts` },
  submissions: { id: 'common.submissions', defaultMessage: `Submissions` },
  feeds: { id: 'common.feeds', defaultMessage: `Feeds` },
  feed: { id: 'common.feed', defaultMessage: 'Feed' },
  newsletters: { id: 'common.newsletters', defaultMessage: `Newsletters` },
  quickpolls: { id: 'common.quickpolls', defaultMessage: `Quick Polls` },
  embeds: { id: 'common.embeds', defaultMessage: `Embeds` },
  almostThere: {
    id: 'common.session.almost.there',
    defaultMessage: `You're almost there!`,
  },
  completeProfileMessage: {
    id: 'common.session.complete.profile.message',
    defaultMessage: `Complete your profile to gain full access to hub features.`,
  },
  sessionCompleteProfile: {
    id: 'common.session.complete.profile',
    defaultMessage: `Complete Profile`,
  },
  ignore: { id: 'common.ignore', defaultMessage: `Ignore` },
  you: { id: 'common.you', defaultMessage: `You` },
  save: { id: 'common.save', defaultMessage: `Save` },
  restore: { id: 'common.restore', defaultMessage: `Restore` },
  saveAndExit: { id: 'common.save.and.exit', defaultMessage: 'Save & Exit' },
  submit: { id: 'common.submit', defaultMessage: `Submit` },
  ok: { id: 'common.ok', defaultMessage: `OK` },
  required: { id: 'common.required', defaultMessage: `Required` },
  cookiesDisabledMessage: {
    id: 'common.cookies.disabled.message',
    defaultMessage: `Please {link} in your browser preferences before signing in.`,
  },
  enableCookie: {
    id: 'common.enable.cookies',
    defaultMessage: `enable cookies`,
  },
  emailVerifiedTitle: {
    id: 'common.email.confirmed.title',
    defaultMessage: `Email Verified`,
  },
  emailVerifiedMessage: {
    id: 'common.email.confirmed.message',
    defaultMessage: `Your email ({email}) has been successfully verified.`,
  },
  emailAccountUnlockedTitle: {
    id: 'common.email.account_unlocked.title',
    defaultMessage: `Account Unlocked`,
  },
  ssoError: {
    id: 'common.sso.error',
    defaultMessage: `Single Sign-On Error`,
  },
  emailAccountUnlockedMessage: {
    id: 'common.email.account_unlocked.message',
    defaultMessage: `Your account has been successfully unlocked.`,
  },
  skipForNow: {
    id: 'common.skip.for.now',
    defaultMessage: `Skip for now`,
  },
  skippedProfileMenuTooltip: {
    id: 'common.skipped.profile.menu.tooltip',
    defaultMessage: `You can always update your profile from the settings menu.`,
  },
  moreInformation: {
    id: 'common.more.information',
    defaultMessage: `More information.`,
  },
  authErrorThirdPartyCookiesDisabled: {
    id: 'common.auth.error.third.party.cookies.disabled',
    defaultMessage: `Please enable third-party cookies and sign in again.`,
  },
  authErrorGeneral: {
    id: 'common.auth.error.general',
    defaultMessage: `Please check your email/username and password and sign in again.`,
  },
  authErrorUnauthorized: {
    id: 'common.auth.error.unauthorized',
    defaultMessage: `Sorry, you don't have permission to access this page.`,
  },
  authErrorNotActiveMember: {
    id: 'common.auth.error.not.active.member',
    defaultMessage: `You'll need to be an active member to view the contents of this community. Please contact your administrator.`,
  },
  authErrorSocial: {
    id: 'common.auth.error.social',
    defaultMessage: `Could not sign in with that account.`,
  },
  author: {
    id: 'common.author',
    defaultMessage: `Author`,
  },

  /* DATES */
  today: {
    id: 'common.dates.today',
    defaultMessage: `Today`,
  },
  yesterday: {
    id: 'common.dates.yesterday',
    defaultMessage: `Yesterday`,
  },
  lastWeek: {
    id: 'common.dates.last.week',
    defaultMessage: `Last week`,
  },
  thisMonth: {
    id: 'common.dates.this.month',
    defaultMessage: `This month`,
  },
  thisQuarter: {
    id: 'common.dates.this.quarter',
    defaultMessage: `This quarter`,
  },
  thisYear: {
    id: 'common.dates.this.year',
    defaultMessage: `This year`,
  },
  last7Days: {
    id: 'common.dates.last.7.days',
    defaultMessage: `Last 7 days`,
  },
  last30Days: {
    id: 'common.dates.last.30.days',
    defaultMessage: `Last 30 days`,
  },
  lastXDays: {
    id: 'common.dates.last.x.days',
    defaultMessage: `Last {numberOfDays} days`,
  },
  customRange: {
    id: 'common.dates.custom.range',
    defaultMessage: `Custom`,
  },
  errorMinLength: {
    id: 'common.error.min.length',
    defaultMessage: `Must be at least {x} characters`,
  },
  errorValidValue: {
    id: 'common.error.valid.value',
    defaultMessage: `Valid {type} required`,
  },
  errorTaken: {
    id: 'common.error.taken',
    defaultMessage: `{what} is taken`,
  },
  update: {
    id: 'common.update',
    defaultMessage: `Update`,
  },
  proceed: {
    id: 'common.proceed',
    defaultMessage: `Proceed`,
  },
  cancel: {
    id: 'common.cancel',
    defaultMessage: `Cancel`,
  },
  skipToContent: {
    id: 'common.skip.to.content',
    defaultMessage: 'Skip to Content',
  },
  unknownError: {
    id: 'common.unknown.error.try.again',
    defaultMessage: 'Unknown error. Please try again later.',
  },
  start: {
    id: 'common.start',
    defaultMessage: `Start`,
  },
  pageOfPages: {
    id: 'common.page.of.pages',
    defaultMessage: '{page} of {pages}',
  },
  reject: { id: 'common.reject', defaultMessage: 'Reject' },
  clear: { id: 'common.clear', defaultMessage: 'Clear' },
  confirmMessage: {
    id: 'common.confirm.message',
    defaultMessage: 'Are you sure?',
  },
  delete: { id: 'common.delete', defaultMessage: 'Delete' },
  owner: {
    id: 'common.roles.owner',
    defaultMessage: 'Owner',
  },
  moderator: {
    id: 'common.roles.moderator',
    defaultMessage: 'Moderator',
  },
  collaborator: {
    id: 'common.roles.collaborator',
    defaultMessage: 'Collaborator',
  },
  orgadmin: {
    id: 'common.roles.orgadmin',
    defaultMessage: 'Org Admin',
  },
  root: {
    id: 'common.roles.root',
    defaultMessage: 'Root',
  },
  guest: {
    id: 'common.roles.guest',
    defaultMessage: 'Guest',
  },
  anonymous: {
    id: 'common.roles.anonymous',
    defaultMessage: 'Anonymous',
  },
  back: { id: 'common.back', defaultMessage: 'Back' },
  admin: { id: 'common.admin', defaultMessage: 'Admin' },
  continue: { id: 'common.continue', defaultMessage: 'Continue' },
  or: {
    id: 'common.or',
    defaultMessage: 'or',
  },
  errorsAlphaNumericOnly: {
    id: 'common.errors.alpha.numeric.only',
    defaultMessage: 'Alphanumeric characters only',
  },
  errorsNumericOnly: {
    id: 'common.errors.numeric.only',
    defaultMessage: 'Numeric characters only',
  },
  errorsDefault: {
    id: 'common.errors.default',
    defaultMessage: 'An error occurred',
  },
  acceptAndContinue: {
    id: 'common.accept.continue',
    defaultMessage: 'Accept and continue',
  },
  dismiss: {
    id: 'common.dismiss',
    defaultMessage: 'Dismiss',
  },
  success: {
    id: 'common.success',
    defaultMessage: 'Success',
  },
  generalServerError: {
    id: 'common.error.wrong',
    defaultMessage: 'Something went wrong',
  },
  errorMsg: {
    id: 'common.errorMsg',
    defaultMessage: 'Error message',
  },
  learnMore: {
    id: 'common.learn.more',
    defaultMessage: 'Learn More',
  },
  gotIt: {
    id: 'common.got.it',
    defaultMessage: 'Got it',
  },
  maintenanceMessage: {
    id: 'common.maintenance.message',
    defaultMessage: `We're working on the site right now. You can continue browsing, but some features might not work.`,
  },
  user: {
    id: 'common.user',
    defaultMessage: 'User',
  },
  status: {
    id: 'common.status',
    defaultMessage: 'Status',
  },
  create: {
    id: 'common.create',
    defaultMessage: 'Create',
  },
  name: {
    id: 'common.name',
    defaultMessage: 'Name',
  },
  title: {
    id: 'common.title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'common.description',
    defaultMessage: 'Description',
  },
  dropdownPlaceholder: {
    id: 'dropdown.placeholder',
    defaultMessage: 'Choose a value...',
  },
  optional: {
    id: 'common.optional',
    defaultMessage: 'Optional',
  },
  information: {
    id: 'common.information',
    defaultMessage: 'Information',
  },
  memberDetails: {
    id: 'common.member.details',
    defaultMessage: 'Member Details',
  },
  memberDetailsDescription: {
    id: 'common.member.details.description',
    defaultMessage:
      'Choose what information you share to ensure that the content you receive is customized for your interests',
  },
  emailAddress: {
    id: 'common.email.address',
    defaultMessage: 'Email Address',
  },
  emailDisabled: {
    id: 'common.email.disabled',
    defaultMessage:
      'This field cannot be changed. Please contact tech support if you need further assistance.',
  },
  revert: {
    id: 'common.revert',
    defaultMessage: 'Revert',
  },
  profile: {
    id: 'common.profile',
    defaultMessage: 'Profile',
  },
  profileData: {
    id: 'common.profile.data',
    defaultMessage: 'Profile Data',
  },
  hub: {
    id: 'common.hub',
    defaultMessage: '{count, plural, one {Hub} other {Hubs}}',
  },
  template: {
    id: 'common.template',
    defaultMessage: '{count, plural, one {Template} other {Templates}}',
  },
  profileVariableSaveError: {
    id: 'common.profile.variable.save.error',
    defaultMessage: 'Entry was not saved',
  },
  profileVariablesErrorHeader: {
    id: 'common.profile.variables.error.header',
    defaultMessage: 'Some updates were not saved. Please try saving again.',
  },
  recipient: {
    id: 'common.recipient',
    defaultMessage: '{count, plural, one {Recipient} other {Recipients}}',
  },
  notification: {
    id: 'common.notification',
    defaultMessage: '{count, plural, one {Notification} other {Notifications}}',
  },
  url: {
    id: 'common.url',
    defaultMessage: 'URL',
  },
  organization: {
    id: 'common.organization',
    defaultMessage: '{count, plural, one {Organization} other {Organizations}}',
  },
  connect: {
    id: 'common.connect',
    defaultMessage: 'Connect',
  },
  address: {
    id: 'common.address',
    defaultMessage: 'Address',
  },
  street: {
    id: 'common.street',
    defaultMessage: 'Street',
  },
  address2: {
    id: 'common.address.two',
    defaultMessage: 'City, Province/State',
  },
  postalCode: {
    id: 'common.address.postal.code',
    defaultMessage: 'Postal / Zip Code',
  },
  country: {
    id: 'common.country',
    defaultMessage: 'Country',
  },
  locale: {
    id: 'common.locale',
    defaultMessage: 'Locale',
  },
  change: {
    id: 'common.change',
    defaultMessage: 'Change',
  },
  addImage: {
    id: 'common.add.image',
    defaultMessage: 'Add Image',
  },
  stream: {
    id: 'common.stream',
    defaultMessage: 'Stream',
  },
  label: {
    id: 'common.label',
    defaultMessage: 'Label',
  },
  content: {
    id: 'common.content',
    defaultMessage: 'Content',
  },
  new: {
    id: 'common.new',
    defaultMessage: 'New',
  },
  edit: {
    id: 'common.edit',
    defaultMessage: 'Edit',
  },
  tag: {
    id: 'common.tag',
    defaultMessage: 'Tag',
  },
  startDatePlaceholderText: {
    id: 'common.dates.start.placeholder',
    defaultMessage: `Start Date`,
  },
  endDatePlaceholderText: {
    id: 'common.dates.end.placeholder',
    defaultMessage: `End Date`,
  },
  facebook: {
    id: 'common.network.facebook',
    defaultMessage: 'Facebook',
  },
  linkedIn: {
    id: 'common.network.linkedin',
    defaultMessage: 'LinkedIn',
  },
  twitter: {
    id: 'common.network.twitter',
    defaultMessage: 'Twitter',
  },
  date: {
    id: 'common.date',
    defaultMessage: 'Date',
  },
  preview: {
    id: 'common.preview',
    defaultMessage: 'Preview',
  },
  confirm: {
    id: 'common.confirm',
    defaultMessage: 'Confirm',
  },
  lastUpdated: {
    id: 'common.last.updated',
    defaultMessage: 'Last Updated',
  },
  company: {
    id: 'common.company',
    defaultMessage: 'Company',
  },
  administrator: {
    id: 'common.administrator',
    defaultMessage: '{count, plural, one {Administrator} other {Administrators}}',
  },
  posts: {
    id: 'common.posts',
    defaultMessage: 'posts',
  },
  passwordRequirements: {
    id: 'common.password.requirements',
    defaultMessage: 'Password Requirements',
  },
  passwordRequirementCriteria: {
    id: 'common.password.requirements.criteria',
    defaultMessage:
      'Passwords must be 8 or more characters, contain at least 1 uppercase letter, 1 lowercase letter, 1 special character and number.',
  },
  typesVideo: {
    id: 'common.types.video',
    defaultMessage: 'Video',
  },
  typesPost: {
    id: 'common.types.post',
    defaultMessage: 'Post',
  },
  typesLink: {
    id: 'common.types.link',
    defaultMessage: 'Link',
  },
  typesArticle: {
    id: 'common.types.article',
    defaultMessage: 'Article',
  },
  typesImage: {
    id: 'common.types.image',
    defaultMessage: 'Image',
  },
  typesAudio: {
    id: 'common.types.audio',
    defaultMessage: 'Audio',
  },
  typesFile: {
    id: 'common.types.file',
    defaultMessage: 'File',
  },
  close: {
    id: 'common.close',
    defaultMessage: `Close`,
  },
  featured: {
    id: 'common.posts.featured',
    defaultMessage: 'Featured',
  },
  pinned: {
    id: 'common.posts.pinned',
    defaultMessage: 'Pinned',
  },
  created: {
    id: 'common.created',
    defaultMessage: 'Created',
  },
  modified: {
    id: 'common.modified',
    defaultMessage: 'Modified',
  },
  accountRemoved: {
    id: 'common.account.removed',
    defaultMessage: 'Account removed',
  },
  statusDrafted: {
    id: 'common.status.drafted',
    defaultMessage: 'Drafted',
  },
  statusRejected: {
    id: 'common.status.rejected',
    defaultMessage: 'Rejected',
  },
  statusScheduled: {
    id: 'common.status.scheduled',
    defaultMessage: 'Scheduled',
  },
  statusFailed: {
    id: 'common.status.failed',
    defaultMessage: 'Failed',
  },
  statusSent: {
    id: 'common.status.sent',
    defaultMessage: 'Sent',
  },
  statusUnknown: {
    id: 'common.status.unknown',
    defaultMessage: 'Unknown',
  },
  role: {
    id: 'common.role',
    defaultMessage: 'Role',
  },
  saveSuccess: {
    id: 'common.save.success',
    defaultMessage: 'Successfully saved changes',
  },
  saveError: {
    id: 'common.save.error',
    defaultMessage: 'Failed to save changes',
  },
  imageUploadSuccess: {
    id: 'common.image.success',
    defaultMessage: 'Successfully saved image',
  },
  imageUploadError: {
    id: 'common.image.error',
    defaultMessage: 'Failed to save image',
  },
  type: {
    id: 'common.type',
    defaultMessage: 'Type',
  },
  reason: {
    id: 'common.reason',
    defaultMessage: 'Reason',
  },
  reset: {
    id: 'common.reset',
    defaultMessage: 'Reset',
  },
  filter: {
    id: 'common.filter',
    defaultMessage: 'Filter',
  },
  done: {
    id: 'common.done',
    defaultMessage: 'Done',
  },
  other: {
    id: 'common.other',
    defaultMessage: 'Other',
  },
  accept: {
    id: 'common.accept',
    defaultMessage: 'Accept',
  },
  decline: {
    id: 'common.decline',
    defaultMessage: 'Decline',
  },
  publish: {
    id: 'common.publish',
    defaultMessage: 'Publish',
  },
  apply: {
    id: 'common.apply',
    defaultMessage: 'Apply',
  },
  cookiePopupLearnMore: {
    id: 'common.cookie.popup.learn.more',
    defaultMessage: 'Read our {policyDisplayText} to learn more.',
  },
  cookiePopupText: {
    id: 'common.cookie.popup.text',
    defaultMessage:
      'This website uses cookies to store information on your device. These cookies allow the site to function correctly and to improve your experience. Read our {hypertext} to learn more.',
  },
  cookiePopupMessage: {
    id: 'common.cookie.popup.message',
    defaultMessage: 'Cookie pop-up message',
  },
  cookieTextEditorInstruction: {
    id: 'common.cookie.text.editor.instruction',
    defaultMessage: 'Highlight select words to add hyperlinks',
  },
  piiConsentDefaultText: {
    id: 'common.pii.consent.default.text',
    defaultMessage: `Your display name and selected profile information can be viewed by all members of the community (when enabled by the Hub Administrator). This may include Personal Identifiable Information (PII). 
          
Please update your display name accordingly, and disable any profile information you would like to hide from other members. You can also update this information at any time in your account settings.`,
  },
  displayNamePopupMessage: {
    id: 'common.display.name.popup.message',
    defaultMessage: 'Display name pop-up message',
  },
  emptyChart: {
    id: 'common.empty.chart',
    defaultMessage: 'Empty Chart',
  },
  signInError: {
    id: 'session.sign.in.error',
    defaultMessage: 'The email or password you entered is incorrect. Please try again.',
  },
  emptyEmailError: {
    id: 'session.empty.email.error',
    defaultMessage: 'An email address is missing. Enter an email address and try again',
  },
  badEmailError: {
    id: 'session.bad.email.error',
    defaultMessage: 'Unable to find that email address. Please revise and try again',
  },
  accountSettings: {
    id: 'common.account.settings',
    defaultMessage: 'Account Settings',
  },
  changePasswordIntroInstructions: {
    id: 'common.change.password.intro.instructions',
    defaultMessage:
      'Click "Edit" to change your account password. You\'ll be required to re-enter your current password.',
  },
  saveChanges: {
    id: 'common.save.changes',
    defaultMessage: 'Save changes',
  },
  currentPassword: {
    id: 'common.current.password',
    defaultMessage: 'Current password',
  },
  createPassword: {
    id: 'common.create.password',
    defaultMessage: 'Create Password',
  },
  newPassword: {
    id: 'common.new.password',
    defaultMessage: 'New password',
  },
  confirmPassword: {
    id: 'common.confirm.password',
    defaultMessage: 'Confirm new password',
  },
  changePasswordInstructions: {
    id: 'common.change.password.instructions',
    defaultMessage: 'Use the form below to change the password for your {accountType} account',
  },
  savePassword: {
    id: 'common.save.password',
    defaultMessage: 'Save Password',
  },
  cancelPassword: {
    id: 'common.cancel.password',
    defaultMessage: 'Cancel and Close',
  },
  passwordCriteria: {
    id: 'common.password.criteria',
    defaultMessage:
      'Passwords must be more than 8 characters, contain at least 1 uppercase letter, 1 lowercase letter, 1 special character and 1 number.',
  },
  errorMinNumber: {
    id: 'common.error.min.number',
    defaultMessage: 'Must be at least one number',
  },
  errorEqualPasswords: {
    id: 'common.error.equal.passwords',
    defaultMessage: 'New password and confirm password must be equal',
  },
  errorMinUppercaseLetter: {
    id: 'common.error.min.uppercaseletter',
    defaultMessage: 'Must be at least one uppercase letter',
  },
  errorMinLowercaseLetter: {
    id: 'common.error.min.lowercaseletter',
    defaultMessage: 'Must be at least one lowercase letter',
  },
  errorMinSpecialCharacter: {
    id: 'common.error.min.specialcharacter',
    defaultMessage: 'Must be at least one special character',
  },
  revokePermission: {
    id: 'common.revoke.permission',
    defaultMessage: 'Revoke permission',
  },
  reply: { id: 'common.reply', defaultMessage: `Reply` },
  //
  // Test new incoming strings from Transifex.
  // https://visioncritical.atlassian.net/browse/S3-25529
  //
  test1: {
    id: 'common.test1',
    defaultMessage: '{user} sent you an {email}',
  },
  test2: {
    id: 'common.test2',
    defaultMessage: '{count, plural, one {user} other {users}}',
  },
  test3: {
    id: 'common.test3',
    defaultMessage: '{count, plural, one {{count} users found} other {{count} users found}}',
  },
  test4: {
    id: 'common.test4',
    defaultMessage:
      'Do you want to send email to {recipientCount, plural, one {# recipient} other {# recipients}} on {formattedDate}?',
  },
  userSession: {
    id: 'hub.settings.user.session',
    defaultMessage: 'User Session',
  },
  userSessionDuration: {
    id: 'hub.settings.user.session.duration',
    defaultMessage: 'Session Duration',
  },
  userSessionDurationInfo: {
    id: 'hub.settings.user.session.duration.info',
    defaultMessage: 'Duration after which a session expires and users are prompted for credentials',
  },
  userSessionDurationOneYear: {
    id: 'hub.settings.user.session.duration.one.year',
    defaultMessage: '1 year',
  },
  userSessionDurationSixMonths: {
    id: 'hub.settings.user.session.duration.six.months',
    defaultMessage: '6 months',
  },
  userSessionDurationThreeMonths: {
    id: 'hub.settings.user.session.duration.three.months',
    defaultMessage: '3 months',
  },
  userSessionDurationOneMonth: {
    id: 'hub.settings.user.session.duration.one.month',
    defaultMessage: '1 month',
  },
  userSessionDurationOneWeek: {
    id: 'hub.settings.user.session.duration.one.week',
    defaultMessage: '1 week',
  },
  userSessionDurationOneDay: {
    id: 'hub.settings.user.session.duration.one.day',
    defaultMessage: '1 day',
  },
  userSessionDurationTwelveHours: {
    id: 'hub.settings.user.session.duration.twelve.hours',
    defaultMessage: '12 hours',
  },
  userSessionDurationBrowserClose: {
    id: 'hub.settings.user.session.duration.browser.close',
    defaultMessage: 'Each time browser is closed',
  },
  userSessionForceSignOut: {
    id: 'hub.settings.user.session.force.sign.out',
    defaultMessage: 'Force Sign Out',
  },
  userSessionForceSignOutInfo: {
    id: 'hub.settings.user.session.force.sign.out.info',
    defaultMessage:
      'Force all sessions to expire and sign out all currently logged-in users simultaneously.',
  },
  userSessionForceSignOutWarning: {
    id: 'hub.settings.user.session.force.sign.out.warning',
    defaultMessage:
      'All users will be signed out from their accounts and will need to enter their credentials to sign in to your Hub.',
  },
  userSessionForceSignOutModalWarning: {
    id: 'hub.settings.user.session.force.sign.out.modal.warning',
    defaultMessage:
      'Are you sure you want to force sign out? All users will be signed out from their accounts and will need to enter their credentials to sign in to your Hub.',
  },
})
